'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[WSSIs]');

var winresServiceSelectItems = function () {
    function winresServiceSelectItems($scope) {
        _classCallCheck(this, winresServiceSelectItems);

        this.$scope = $scope;
    }

    _createClass(winresServiceSelectItems, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.values = {};

            this.ngModelCtrl.$render = function () {
                return _this.render(_this.ngModelCtrl.$viewValue);
            };
            this.ngModelCtrl.$isEmpty = function (value) {
                return _.toArray(value).length === 0;
            };

            this.ngModelCtrl.$validators.min = function (modelValue, viewValue) {
                return _this.min === undefined || _.toArray(modelValue).length >= _this.min;
            };

            this.ngModelCtrl.$validators.max = function (modelValue, viewValue) {
                return _this.max === undefined || _.toArray(modelValue).length <= _this.max;
            };

            this.$scope.$watchCollection(function () {
                return _this.items;
            }, function () {
                return _this.updateItems();
            });
        }
    }, {
        key: 'updateItems',
        value: function updateItems() {
            var _this2 = this;

            if (!_.isArrayLike(this.items)) {
                // Invalid item list, remove all selections
                log.warn('Invalid item list:', this.items);
                this.values = {};
                this.read();
                return;
            }

            // IDs of old and new items
            var oldIDs = _.keys(this.values);
            var newIDs = this.itemIDs();

            // IDs of added and removed items
            var addedIDs = _.difference(newIDs, oldIDs);
            var removedIDs = _.difference(oldIDs, newIDs);

            if (addedIDs.length > 0) {
                // log('Added', addedIDs.length, 'items:', addedIDs);
            }
            if (removedIDs.length > 0) {
                log('Removed', removedIDs.length, 'items:', removedIDs);
            }

            // Add records for added items
            _.forEach(addedIDs, function (id) {
                _this2.values[id] = false;
            });

            // Remove records of removed items
            _.forEach(removedIDs, function (id) {
                delete _this2.values[id];
            });

            // If items were removed, some current selections may no longer be valid.
            // That will affect the output.
            // On the other hand, adding items cannot change the output, since the
            // default value for items is false.
            // So, we only need to update the output if items were removed.
            if (removedIDs.length > 0) {
                // Update output accordingly
                this.read();
            }
        }
    }, {
        key: 'render',
        value: function render(value) {
            // log('Input:', value);

            if (!_.isObject(value)) {
                log.warn('Provided model value is invalid:', value);
                value = {};
            }

            // Take only the parts of the input that correspond to valid item IDs
            var ids = this.itemIDs();
            var values = _.pick(value, ids);

            // Convert from 0/N to true/false
            this.values = _.mapValues(values, function (x) {
                return x > 0;
            });
        }
    }, {
        key: 'read',
        value: function read(itemID) {
            var _this3 = this;

            // If we're in radio mode, toggle all others off
            if (this.isSingle()) {
                _.forEach(this.itemIDs(), function (id) {
                    if (id != itemID) {
                        _this3.values[id] = false;
                    }
                });
            }

            // Convert output to form { foo: 0, bar: 1}
            var ids = this.selectedItemIDs();
            var value = _.fromPairs(_.map(ids, function (id) {
                return [id, 1];
            }));
            // log('Output:', value);

            this.ngModelCtrl.$setViewValue(value);
        }
    }, {
        key: 'itemIDs',
        value: function itemIDs() {
            return _.map(this.items, function (p) {
                return _.toString(p.id);
            });
        }
    }, {
        key: 'selectedItemIDs',
        value: function selectedItemIDs() {
            var _this4 = this;

            var ids = this.itemIDs();
            return _.filter(ids, function (id) {
                return _this4.values[id];
            });
        }
    }, {
        key: 'count',
        value: function count() {
            return _.filter(this.values).length;
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled(itemID) {
            if (this.disabled !== undefined && this.disabled !== false) {
                // The whole component is disabled
                return true;
            } else if (this.capacity(itemID) === 0 && !this.values[itemID]) {
                // The item is out of capacity, and isn't selected yet.
                return true;
            } else if (!this.isSingle() && this.count() === this.max && !this.values[itemID]) {
                // We're not in radio mode, the maximum amount of items
                // is selected, and this particular item isn't selected yet.
                return true;
            } else {
                return false;
            }
        }
    }, {
        key: 'capacity',
        value: function capacity(itemID) {
            var item = _.find(this.items, function (item) {
                return item.id === itemID;
            });
            return item ? item.capacity : undefined;
        }

        // True if exactly one item must be selected.

    }, {
        key: 'isSingle',
        value: function isSingle() {
            return this.min == 1 && this.max == 1;
        }
    }]);

    return winresServiceSelectItems;
}();

winresServiceSelectItems.$inject = ['$scope'];

_module3.default.component('winresServiceSelectItems', {
    template: require('./winresServiceSelectItems.html'),
    controller: winresServiceSelectItems,
    require: {
        ngModelCtrl: 'ngModel'
    },
    bindings: {
        // List of items. NOTE: The id field is meant to be unique to each
        // item. It is used to detect when an item is added or removed,
        // so that the item's selection can also be removed.
        // [
        //     {
        //         id: 42
        //         name: 'John Smith',
        //         priceLabel: 'adult',
        //         price: 5,
        //         capacity: 99
        //     },
        //     {
        //         id: 666,
        //         name: 'Mary Smith',
        //         priceLabel: 'child',
        //         price: 2.5,
        //         capacity: 50
        //     }
        // ]
        items: '<',

        // IDs of selected items.
        ngModel: '<',

        // If this attribute is set (to anything), the component is disabled.
        disabled: '@',

        // At least this many items must be selected.
        min: '<',

        // At most this many items must be selected.
        max: '<'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceSelectItems/winresServiceSelectItems.js
// module id = 463
// module chunks = 2